export const COLUMN_CONFIG = {
  DEFAULT_WIDTH: 150,
  MIN_WIDTH: 50,
  MAX_WIDTH: 800,
  INDEX_WIDTH: 50,
} as const

export const STYLES_CONFIG = {
  cell: {
    padding: '4px 8px',
    fontSize: '13px',
  },
  header: {
    padding: '8px',
    fontSize: '12px',
    fontWeight: 600,
  },
  borderRadius: '8px',
  scrollbarWidth: 8,
} as const

export const EXPORT_CONFIG = {
  csvDelimiter: ',',
  csvEnclosure: '"',
  excelSheetName: 'Data',
  dateFormat: 'YYYY-MM-DD',
  datetimeFormat: 'YYYY-MM-DD HH:mm:ss',
} as const

export const ANIMATION_CONFIG = {
  selectionDuration: 150,
  copyFlashDuration: 800,
  hoverTransition: 120,
} as const
